import * as yup from 'yup'

export const schemaSupplier = yup.object().shape({
  companyName: yup.string().required(),
  email: yup.string().required(),
  document: yup.string().required(),
  phone: yup.string().phone({ required: true }),
})

export default schemaSupplier
